/** Highlight / clear TEVO Seatics map selection from ticket list hover */
export function highlightTicketOnMap(ticket) {
  if (!ticket || !window.Seatics?.MapComponent?.getTgFromId) return;
  const tgId = ticket.tgID ?? ticket.id;
  try {
    const ticketGroup = window.Seatics.MapComponent.getTgFromId(tgId);
    if (ticketGroup) {
      window.Seatics.MapComponent.highlightTicket(ticketGroup);
    }
  } catch {
    /* map not ready */
  }
}

export function clearMapHighlight() {
  try {
    window.Seatics?.MapComponent?.clearHighlight?.();
  } catch {
    /* ignore */
  }
}

/** Match map-filtered Seatics rows back to normalized ticket row ids */
export function findTicketRowIdForSeaticsItem(seaticsItem, ticketRows) {
  if (!seaticsItem || !ticketRows?.length) return null;
  const tgId = String(seaticsItem.tgID ?? seaticsItem.id ?? "");
  const direct = ticketRows.find((r) => r.id === tgId);
  if (direct) return direct.id;
  const bySection = ticketRows.find(
    (r) =>
      r.name &&
      seaticsItem.tgUserSec &&
      r.name.toLowerCase() === String(seaticsItem.tgUserSec).toLowerCase()
  );
  return bySection?.id ?? null;
}
